import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { InputAdornment, Paper } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { sign, getLoggedUser } from "../../store/auth";
import { useDispatch, useSelector } from "react-redux";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const theme = createTheme();

export default function SignIn() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const loggedUser = useSelector(getLoggedUser);
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [receiptFile, setReceiptFile] = useState(null);
  const from = location.state?.from?.pathname || "/";

  const handleLogin = async () => {
    const response = await instance.loginPopup(loginRequest).catch((e) => {
      console.log(e);
    });
    if (response.accessToken) navigate("/");
  };

  const handleSupportLogin = (e) => {
    e.preventDefault();
    dispatch(sign(username, password));
  };

  useEffect(() => {
    //console.log(loggedUser);
    if (loggedUser) navigate(from, { replace: true });
  }, [loggedUser]);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <ThemeProvider theme={theme} >

      <Box component="main" sx={{ minWidth: "45vw" }} >
        <CssBaseline />

        <Paper elevation={3} sx={{ padding: "11px 24px", }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",

            }}
          >
            {/* <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar> */}
            <Typography component="h1" variant="h5">
              SIGN IN
            </Typography>
          </Box>
          <Box component="form" noValidate sx={{ mt: 1 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, padding: "14px 16px" }}
                onClick={handleLogin}
              >
                Sign In with your assigned Microsoft Account
              </Button>
              <Typography component="h1" variant="h5">
                OR
              </Typography>

              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                onChange={(e) => setUsername(e.target.value)}
              />
              
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type={showPassword ? 'text' : 'password'}
                id="password"
                autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Grid container>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={<Checkbox value="remember" color="primary" />}
                    label="Remember me"
                  />
                </Grid>
                <Grid item xs={6} sx={{ alignContent: "center" }}>
                  <Link href="/forgot-password" variant="body2" sx={{ float: "right", textDecoration: "none" }}>
                    Forgot Password?
                  </Link>
                </Grid>
              </Grid>
              <Button
                fullWidth

                variant="contained"
                sx={{ mt: 3, mb: 2, padding: "14px 16px" }}
                onClick={handleSupportLogin}
              >
                Sign In with your customer support portal Account
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </ThemeProvider>
  );
}
